/// <amd-module name="Artifacts/PackageRecycleBin/components/PackageRecycleBinHub" />

import { NoPackages } from "Artifacts/PackageRecycleBin/components/NoPackages";
import { RecycleBinTable } from "Artifacts/PackageRecycleBin/components/RecycleBinPackagesTable";
import * as Res from "Artifacts/PackageRecycleBin/Resources";
import { IDeletedPackageVersion } from "Artifacts/PackageRecycleBin/types";
import { DefaultLoader } from "Artifacts/Root/components/DefaultLoader";
import { ComponentState } from "Artifacts/Root/Constants";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import { ICommand } from "Artifacts/Root/protocols/types";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { ScreenSize } from "VSS/Core/Util/Screen";
import {
  CustomHeader,
  HeaderBackButton,
  HeaderTitle,
  HeaderTitleArea,
  HeaderTitleRow,
  TitleSize,
} from "VSSUI/Header";
import { HeaderCommandBar, IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { IListSelection } from "VSSUI/List";
import { Page } from "VSSUI/Page";
import { ScreenSizeObserver } from "VSSUI/Utilities/ScreenSize";

export interface IPackageRecycleBinHubComponentProps {
  componentState: ComponentState;
  pkgVersions?: IDeletedPackageVersion[];
  recycleBinListSelection: IListSelection;
  commands: ICommand[];
  emptyRecycleBin: () => void;
}

export const PackageRecycleBinHub: React.FC<IPackageRecycleBinHubComponentProps> = ({
  componentState,
  pkgVersions,
  recycleBinListSelection,
  commands,
  emptyRecycleBin,
}) => {
  const { feed, resolution } = useFeed();
  const history = useHistory();
  const headerCommands: IHeaderCommandBarItem[] = [
    {
      id: "emptyRecycleBin",
      text: Res.EmptyRecycleBin_Button,
      onActivate: () => {
        emptyRecycleBin();
      },
      isPrimary: true,
      disabled: pkgVersions === undefined || pkgVersions.length === 0,
      rank: 0,
    },
    ...commands.map((command) => ({
      id: command.id,
      text: command.displayName,
      iconProps: command.iconProps,
      onActivate: () => {
        feed &&
          command.action({
            feed,
            pkgVersions,
          });
      },
      rank: 1,
    })),
  ];

  return (
    <Page className="package-recycle-bin-hub">
      <CustomHeader className="bolt-header-with-commandbar">
        <HeaderTitleArea>
          <HeaderTitleRow>
            <HeaderBackButton buttonProps={{ onClick: history.goBack }} />
            <ScreenSizeObserver>
              {(screenSizeProps: { screenSize: ScreenSize }) => {
                const xsScreen = screenSizeProps.screenSize === ScreenSize.xsmall;
                return (
                  <HeaderTitle className="text-ellipsis" titleSize={TitleSize.Large}>
                    {xsScreen ? Res.RecycleBinTable_Title_ShortVersion : Res.RecycleBinTable_Title}
                  </HeaderTitle>
                );
              }}
            </ScreenSizeObserver>
          </HeaderTitleRow>
        </HeaderTitleArea>
        <HeaderCommandBar items={headerCommands} buttonCount={10} />
      </CustomHeader>
      <DefaultLoader state={resolution}>
        <DefaultLoader state={componentState} spinnerLabel={Res.RecycleBinLoadingSpinnerLabel}>
          <div className="page-content page-content-top">
            {pkgVersions && pkgVersions.length > 0 ? (
              <RecycleBinTable packageVersions={pkgVersions} selection={recycleBinListSelection} />
            ) : (
              <NoPackages />
            )}
          </div>
        </DefaultLoader>
      </DefaultLoader>
    </Page>
  );
};
